import { render, staticRenderFns } from "./tratamientosprogramados.vue?vue&type=template&id=3cd1349e&scoped=true"
import script from "./tratamientosprogramados.vue?vue&type=script&lang=js"
export * from "./tratamientosprogramados.vue?vue&type=script&lang=js"
import style0 from "./tratamientosprogramados.vue?vue&type=style&index=0&id=3cd1349e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1349e",
  null
  
)

export default component.exports